// Digitale Visitenkarten — R-NetWork GmbH
// Branding nach praxissoftware.org (Logo + Farben)
export const BUSINESS_CARDS = [
  {
    slug: "oliver-rudolph",
    firstName: "Oliver",
    lastName: "Rudolph",
    initials: "OR",
    title: "Geschäftsführer",
    company: "R-NetWork GmbH",
    tagline: "IT für Ärzte",
    phone: "+49 69 84847507",
    mobile: "+49 177 6517512",
    email: "oliver.rudolph@r-network.de",
    web: "r-network.de",
  },
  {
    slug: "thomas-roell",
    firstName: "Thomas",
    lastName: "Röll",
    initials: "TR",
    title: "Head of IT Infrastructure",
    company: "R-NetWork GmbH",
    tagline: "IT für Ärzte",
    phone: "+49 69 84847507",
    mobile: "+49 177 9197155",
    email: "thomas.roell@r-network.de",
    web: "r-network.de",
  },
];

export const getCardBySlug = (slug) =>
  BUSINESS_CARDS.find((c) => c.slug === slug) || null;
